import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

// const Router = require('vue-router')

// import Index from '@/views/Index'
// import Example from '@/views/Example'
// import Detail from '@/views/Detail'
// import AboutUs from '@/views/AboutUs'
// import Service from '@/views/Service'
// import IndustryExperience from '@/views/IndustryExperience'
// import Product from '@/views/Product'
// import ContactUs from '@/views/ContactUs'
// import ContactUs from '@/views/Method'

const Index = () => import('@/views/Index')
const Example = () => import('@/views/Example')
const Detail = () => import('@/views/Detail')
const AboutUs = () => import('@/views/AboutUs')
const Service = () => import('@/views/Service')
const IndustryExperience = () => import('@/views/IndustryExperience')
const Product = () => import('@/views/Product')
const ContactUs = () => import('@/views/ContactUs')
const Method = () => import('@/views/Method')

// import jquery from 'jquery'

export default new Router({

    routes: [{
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/example',
            name: 'Example',
            component: Example
        },
        {
            // 向指定组件传参  components: { default: User, sidebar: Sidebar }, props: { default: true, sidebar: false }
            path: '/detail/:id',
            name: 'Detail',
            props: true,
            component: Detail
        },
        {
            path: '/aboutus',
            name: 'AboutUs',
            component: AboutUs
        },
        {
            path: '/service',
            name: 'Service',
            component: Service
        },
        {
            path: '/industry-experience',
            name: 'IndustryExperience',
            component: IndustryExperience
        },
        {
            path: '/product',
            name: 'Product',
            component: Product
        },
        {
            path: '/contact-us',
            name: 'ContactUs',
            component: ContactUs,
        },
        {
            path: '/method',
            name: 'Method',
            component: Method,
        }
        
    ],
    //回到顶部
    scrollBehavior (to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    }
})